import { gsap } from "gsap";

$(document).ready(function () {
  if ($(".readmore--pulse").length) {
    var buttonWidth = $(".readmore--pulse .pulse-line").width() * -1.55;
    var tl = gsap.timeline({ paused: true });

    tl.from(".readmore--pulse .heartbeat-line", {
      duration: 1.3,
      x: buttonWidth,
    });

    $(".readmore--pulse").hover(
      function () {
        tl.play();
      },
      function () {
        tl.reverse();
      }
    );
  }
  
  // if ($(".c-guidelines-whole-doc-wrapper").length) {
  //   debugger;
  //   var buttonWidth =
  //     $(".c-guidelines-whole-doc-wrapper .pulse-line").width() * -1.55;
  //   var tl = gsap.timeline({ paused: true });

  //   tl.from(".c-guidelines-whole-doc-wrapper .heartbeat-line", {
  //     duration: 1.3,
  //     x: buttonWidth,
  //   });

  //   $(".c-guidelines-whole-doc-wrapper").hover(
  //     function () {
  //       tl.play();
  //     },
  //     function () {
  //       tl.reverse();
  //     }
  //   );
  // }

  // create individual timelines
  if ($(".c-guidelines-whole-doc-wrapper").length) {
    $(".c-guidelines-whole-doc-wrapper").each(function (i, el) {
      // debugger;

      // create timeline for element, paused
      var tl = gsap.timeline({ paused: true });

      // get arrow
      var pulse = $(el).find(".pulse-line");

      var buttonWidth = $(pulse).width() * -1.7;

      // create tween of the timeline in a variable
      var t = tl.from($(pulse), {
        duration: 1.3,
        x: buttonWidth,
      });

      // store the tween timeline in the js DOM node
      pulse.animation = t;

      $(el).hover(
        function () {
          pulse.animation.play();
        },
        function () {
          pulse.animation.reverse();
        }
      );
    });
  }

});
